import React from "react";
import Template from "../components/Template";

function PrivacyPolicy() {
  return (
    <Template>
      <div className="section-lgx pb-0"></div>
      <section className="section-lgx">
        <div className="container">
          <h1>Privacy Policy</h1>
          <p className="updated-date">Last updated: 7 January 2026</p>
          <p>
            DailyFitZone is owned and operated by CoachElite.
          </p>
          <h5>1. Introduction</h5>
          <p>
            Welcome to <strong>Coach Elite</strong> (“we”, “us”, “our”). This
            Privacy Policy explains how we collect, use, disclose, and protect
            your personal information when you use our website, applications,
            and services (collectively, the “Services”).
          </p>
          <p>
            By accessing or using the Services, you agree to the terms of this
            Privacy Policy.
          </p>

          <p>
            This Privacy Policy should be read together with our Terms &
            Conditions.
          </p>

          <h5>2. Information We Collect</h5>

          <h3>a) Personal Information</h3>
          <p>
            We may collect personally identifiable information that you
            voluntarily provide when you:
          </p>
          <ul>
            <li>Create an account</li>
            <li>
              Subscribe to newsletters, training plans, or coaching programs
            </li>
            <li>Fill out forms or contact us</li>
            {/* <li>Sign up for newsletters or updates</li> */}
          </ul>

          <p>Examples may include:</p>
          <ul>
            <li>Full name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Contact details</li>
            <li>Payment details when necessary</li>
            <li>
              Payment information is processed securely by third-party payment
              gateways. We do not store your card or banking details.
            </li>
          </ul>
          <br />
          <h3>b) Usage Data</h3>
          <p>Automatically collected when you visit or use the Services:</p>
          <ul>
            <li>IP address</li>
            <li>Browser type and settings</li>
            <li>Pages visited</li>
            <li>Time and date of visit</li>
            <li>Device information</li>
            <li>Cookies and tracking technologies</li>
          </ul>

          <h5>3. How We Use Your Information</h5>
          <ul>
            <li>Providing and improving our Services</li>
            <li>Managing your account and user profile</li>
            <li>Communicating about updates, offers, and newsletters</li>
            <li>Customer support and technical assistance</li>
            <li>Analytics and performance measurement</li>
            <li>Legal compliance and safety measures</li>
          </ul>

          <h5>4. Cookies & Tracking Technologies</h5>
          <p>
            We use cookies, web beacons, and similar technologies to improve
            your experience, analyze trends, administer the site, and for
            marketing efforts.
          </p>
          <p>
            You can control cookie preferences through your browser settings.
          </p>
          <p>
            By using our Services, you consent to our use of cookies unless
            disabled through your browser settings.
          </p>

          <h5>5. Sharing Your Information</h5>
          <p>We may share your information with:</p>
          <ul>
            <li>
              Third-party service providers (hosting, analytics, email services)
            </li>
            <li>Legal or regulatory authorities when required by law</li>
            <li>Business partners who help us operate the Services</li>
            <li>
              We only share information to the extent necessary to operate and
              improve our Services.
            </li>
          </ul>
          <p>
            We do <strong>not</strong> sell your personal information to
            unaffiliated third parties.
          </p>

          <h5>6. Data Security</h5>
          <p>
            We implement reasonable technical and organizational measures to
            protect your personal information from loss, unauthorized access,
            and misuse. However, no internet transmission is 100% secure.You
            acknowledge that you share information with us at your own risk.
          </p>

          <h5>7. Your Rights</h5>
          <p>
            Depending on your location and applicable law, you may have the
            right to:
          </p>
          <ul>
            <li>Access your personal data</li>
            <li>Update or correct your information</li>
            <li>Request deletion of your data</li>
            <li>Withdraw consent for processing</li>
            <li>Object to direct marketing</li>
            <li>India does not strictly enforce GDPR wording.</li>
          </ul>

          <h5>8. International Transfers</h5>
          <p>
            Your data may be transferred and stored in countries other than
            where you live. If such transfers occur, we ensure appropriate
            safeguards are in place.
          </p>

          <p>
            Such transfers are conducted in compliance with applicable data
            protection laws.
          </p>

          <h5>9. Third-Party Links</h5>
          <p>
            Our Services may contain links to third-party websites or services
            that are not controlled by us. Their privacy practices are governed
            by their own policies.
          </p>

          <h5>10. Children’s Privacy</h5>
          <p>
            Our Services are not intended for individuals under 18 years of age.
          </p>

          <h5>11. Changes to This Policy</h5>
          <p>
            We may periodically update this Privacy Policy. We will post changes
            on this page with an updated date. Continued use of the Services
            after changes signifies acceptance.
          </p>

          <h5>12. Contact Us</h5>
          <p>
            If you have any questions about this Privacy Policy or your personal
            data, email us at:
          </p>
          <p>
            📧{" "}
            <a href="mailto:coaching@dailyfitzone.com">
              coaching@dailyfitzone.com
            </a>
            <br />
            Coach Elite
            <br />
            India
          </p>
        </div>
      </section>
    </Template>
  );
}

export default PrivacyPolicy;
